import React, { Component } from 'react';
import cross from '../../assets/images/close_popup.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/shared/PreviewDocument.css';
import 'react-calendar/dist/Calendar.css';
import Loader from 'react-loader';
class PreviewDocumentModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageLink: '',
            loaderTime: true,
            profileData: this.props.profileData,
        }
    }
    componentDidMount() {
        console.log(this.state.profileData)
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ loaderTime: this.props.profileData != undefined ? false : true })
        this.setState({ imageLink: this.state.profileData });
        console.log('componentWillReceiveProps', nextProps, this.state.profileData, this.state.loaderTime);
        this.setState(nextProps);
    }
    render() {
        return (
            <div class="previewDocumentModalOuter" >
                <div class="previewDocumentModalInner" style={{maxWidth: "80%"
                    // ((window.screen.width)*80/100)
                    }}
                     >
                    <Loader
                        loaded={!this.state.loaderTime}
                        lines={10}
                        length={10}
                        width={10}
                        radius={10}
                        corners={1}
                        rotate={0}
                        direction={1}
                        color="#000"
                        speed={1}
                        trail={60}
                        shadow={false}
                        hwaccel={false}
                        className='spinner'
                        zIndex={2e9}
                        top="50%"
                        left="50%"
                        scale={1.0}
                        loadedClassName="loadedContent"
                    />
                    <div className='previewDocumentcross' >
                        <img src={cross} width="21" height="21" onClick={this.props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
                    </div>
                    <div style={{ marginTop: '1.5%' }}>
                        <img alt="Mobile Image"
                            src={this.state.imageLink}
                            // width="100px"
                            style={{width: "100%"}}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
export default PreviewDocumentModal;